export const isBrowserMonitoringEnabled = (): boolean =>
  !!(
    process.env.NEXT_PUBLIC_NEW_RELIC_ACCOUNT_ID &&
    process.env.NEXT_PUBLIC_NEW_RELIC_APPLICATION_ID &&
    process.env.NEXT_PUBLIC_NEW_RELIC_BROWSER_LICENSE_KEY
  );
